var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpanishFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21Z",
    fill: "#FFDB44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3704 7.5C18.9517 3.70333 15.2915 1 11 1C6.70847 1 3.04834 3.70333 1.62961 7.5L20.3704 7.5Z",
    fill: "#D90026"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62961 14.5C3.04834 18.2967 6.70847 21 11 21C15.2915 21 18.9517 18.2967 20.3704 14.5L1.62961 14.5Z",
    fill: "#D90026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanishFlag);
export default __webpack_public_path__ + "static/media/spanish-flag.de2cc209839bb75d4ded0216456fdc85.svg";
export { ForwardRef as ReactComponent };